import { useEffect } from "react";
import { AppToasterV2, MultiStepItemProps } from "@ucl/library";
import { BasicInformationForm } from "./BasicInformationForm";
import { FinancialApplicationSection } from "@/types/enums";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { FinancialApplicationFormSectionContextType, useFinancialApplicationFormSectionValidation } from "@/hooks/useFinancialApplicationFormSectionValidation";
import { useFinancialApplicationForm } from "@/hooks/useFinancialApplicationForm";

export interface BasicInformationFormStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const BasicInformationFormStep: React.FC<BasicInformationFormStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <BasicInformationFormStepInner {...props} />
    </RequireAuth>
  );
};

const BasicInformationFormStepInner: React.FC<BasicInformationFormStepProps> = (props) => {
  const { validateFinancialApplicationFormSection } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId,
    FinancialApplicationSection.PersonInformationBasicInfo
  );

  const { refreshFinancialApplication } = useFinancialApplicationForm(props.financialApplicationId);

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const { isValid } = await validateFinancialApplicationFormSection();

      if (!isValid) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
        return false;
      }
      return true;
    });
  }, [props.financialApplicationId, validateFinancialApplicationFormSection]);

  // Refresh data when component mounts to ensure we have the latest data
  // This is especially important after Plaid verification which may have updated the backend
  // TODO: check to see if this is resolved since we now use websockets.
  useEffect(() => {
    refreshFinancialApplication();
  }, []);

  return (
    <section className="basic-information step-section">
      <div className="basic-information__header step-header">Your Information</div>
      <div className="basic-information__subtitle step-subtitle">
        Some information has been pre-filled from your ID. Please confirm before proceeding.
      </div>

      <div className="basic-information-form__content step-content">
        <BasicInformationForm
          financialApplicationId={props.financialApplicationId}
          showHeader={true}
          validationContextType={FinancialApplicationFormSectionContextType.Applicant}
        />
      </div>
    </section>
  );
};
